module.exports = __webpack_public_path__ + "img/Filimundus.1bc0871a.png";